<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/1.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能网络产品解决方案</h3>
            <p class="title-details">
              支持人脸识别、人脸比对，人脸录像快速检索，识别速度快，准确率高；并同步手机报警推送，重要事件不错过。
              AI人形检测：
              支持人形检测，检测距离远、检测数量多，有效降低漏保率，提升监控报警安全等级；并同步手机报警推送，重要事件不错过。
              云存储：
              人形检测、人脸检测报警录像实时上传至云端进行存储，安全可靠，偷不走，砸不坏；
            </p>
            <div
              style="display:flex; align-item:center;justify-content:space-between;"
            >
              <van-button
                v-show="showVideo"
                round
                class="title-box-bottom-video"
                @click="
                  () => {
                    this.$router.push({
                      name: 'video',
                      query: {
                        src: 'static/video/AIcamerasolution.mp4'
                      }
                    });
                  }
                "
              >
                <van-icon :name="require('../assets/images/play.png')" />
                <span class="text">AI摄像机解决方案</span>
              </van-button>
              <!-- <van-button
                v-show="showVideo"
                round
                class="title-box-bottom-video"
                @click="
                  () => {
                    this.$router.push({
                      name: 'video',
                      query: {
                        src: 'static/video/AIsmartparkingsolution.mp4'
                      }
                    });
                  }
                "
              >
                <van-icon :name="require('../assets/images/play.png')" />
                <span class="text">AI智能车位解决方案</span>
              </van-button> -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active">
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box text">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" height="25.3vh" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,
      messageList: [
        {
          id: 1,
          title: "NVR",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/playPPT.png"),
            //   text: "播放PPT",
            //   url: "/video",
            //   src: require("../assets/video/AI摄像机解决方案~1.mp4")
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/newAdd/43.jpg"),
              articletitle: "AI智能高清网络POE NVR",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "8/16口POE IPC接入"
                    },
                    {
                      light: "支持单盘/双硬盘存储"
                    },
                    {
                      light: "支持人脸检测，人形检测，人脸录像回放"
                    },
                    {
                      light: "支持云存储"
                    },
                    {
                      light: "支持手机短视频报警推送"
                    }
                  ]
                }
              ],
              have: true,
              href: "https://www.jufenginfo.com/product-list-6-208-209.html"
            },
            {
              id: 1 - 1 - 2,
              src: require("../assets/images/product/P3920580NVR.jpg"),
              articletitle: "AI智能高清网络NVR",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 2 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "10/16/32路高清4K接入"
                    },
                    {
                      light: "支持单盘/双盘/四盘位存储"
                    },
                    {
                      light: "支持人脸检测，人形检测，人脸录像回放"
                    },
                    {
                      light: "支持云存储"
                    },
                    {
                      light: "支持手机短视频报警推送"
                    }
                  ]
                }
              ],
              have: true,
              href: "http://www.jufenginfo.com/product-list-6-26.html"
            }
          ]
        },
        {
          id: 2,
          title: "IPC",
          details: "",
          buttonList: [],
          articleList: [
            {
              id: 2 - 1 - 1,
              src: require("../assets/images/newAdd/1.jpg"),
              articletitle: "AI智能摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "2MP/3MP/5MP/8MP高清像素"
                    },
                    {
                      light: "支持人形检测、人脸检测等智能功能"
                    },
                    {
                      light: "支持红外/双光警戒"
                    },
                    {
                      light: "支持手机报警推送"
                    },
                    {
                      light: "支持接入蜂云"
                    }
                  ]
                }
              ],
              have: true,
              href: "https://www.jufenginfo.com/product-list-5-20.html"
            },
            {
              id: 2 - 1 - 2,
              src: require("../assets/images/newAdd/4.jpg"),
              articletitle: "AI智能车牌抓拍摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 2 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "500万高清像素"
                    },
                    {
                      light: "支持多种车牌识别"
                    },
                    {
                      light: "识别速度快，准确率高"
                    },
                    {
                      light: "适应复杂环境识别"
                    }
                  ]
                }
              ],
              have: false,
              href: ""
            },
            {
              id: 2 - 1 - 3,
              src: require("../assets/images/newAdd/7.jpg"),
              articletitle: "AI智能人脸抓拍摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 3 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持多人脸检测"
                    },
                    {
                      light: "识别速度快，准确率高"
                    },
                    {
                      light: "支持口罩识别，未带口罩识别"
                    },
                    {
                      light: "支持语音播报"
                    }
                  ]
                }
              ],
              have: false,
              href: ""
            },
            {
              id: 2 - 1 - 4,
              src: require("../assets/images/newAdd/10.jpg"),
              articletitle: "AI智能梯控摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 4 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "支持电瓶车检测"
                    },
                    {
                      light: "支持声光警戒"
                    },
                    {
                      light: "支持联动梯控"
                    },
                    {
                      light: "支持语音播报"
                    }
                  ]
                }
              ],
              have: false,
              href: ""
            }
          ]
        }
      ]
    };
  },
  created: function() {},
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      console.log(val);
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
